export function getPublicApiCallUrl (callUrl: string, publicApiUrl?: string): string {
  // shortcut: force public api rewrite using env url
  if (publicApiUrl) {
    const [, path] = callUrl.split(publicApiUrl)
    if (path) {
      return `${publicApiUrl}${path}`
    }
  }

  // default
  // proper URLs already present under routingConfig.public_api object
  // e.g. https://pl.fizjoterapia.t1.booksy.pm/public-api/pl/oauth2/authorize/
  return callUrl
}
